import React from 'react';
import './currentPositionMarker.scss';

const CurrentPositionMarker = () => {
  return (
    <div className="sb-pointer"></div>
  );
};

export default CurrentPositionMarker;
